import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { Else, If } from "react-condition";
import Loading from "./Loading";
import axios from "../services/axios";
import Checkbox from "../pages/Dashboard/ApplicationEditor/Checkbox";
import DateField from "../pages/Dashboard/ApplicationEditor/DateField";
import EmailField from "../pages/Dashboard/ApplicationEditor/EmailField";
import NumberField from "../pages/Dashboard/ApplicationEditor/NumberField";
import PasswordField from "../pages/Dashboard/ApplicationEditor/PasswordField";
import Radio from "../pages/Dashboard/ApplicationEditor/Radio";
import Select from "../pages/Dashboard/ApplicationEditor/Select";
import TextArea from "../pages/Dashboard/ApplicationEditor/TextArea";
import TextField from "../pages/Dashboard/ApplicationEditor/TextField";
import TextTable from "../pages/Dashboard/ApplicationEditor/TextTable";
import { useHistory } from "react-router-dom";

function getComponentFromType(type) {
  if (type === "checkbox") return Checkbox;
  if (type === "date") return DateField;
  if (type === "email") return EmailField;
  if (type === "number") return NumberField;
  if (type === "password") return PasswordField;
  if (type === "radio") return Radio;
  if (type === "select") return Select;
  if (type === "textarea") return TextArea;
  if (type === "text") return TextField;
  if (type === "texttable") return TextTable;
  return <div>Cannot be edited</div>;
}

function ResponseEditor(props) {
  //console.log("props editor", props)
  const { response } = props;
  const Component = getComponentFromType(response.element.type);
  return <Component {...props} />;
}

function CandidateSingleView({ id }) {
  // States
  const [candidate, setCandidate] = useState();
  const [changeAnswer, setChangeAnswer] = useState({});
  const [answerValue, setAnswerValue] = useState({});
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  // Effects
  useEffect(() => {
    loadCandidate();
  }, []);

  // console.log("candidate", candidate)

  async function loadCandidate() {
    try {
      const { data } = await axios.get("candidates/" + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      setCandidate(data);
      setIsLoading(false);
    } catch (e) {
      console.error(e);
    }
  }

  async function onClickSaveChanges() {
    try {
      //console.log(`Candidate responses`, candidate.responses);
      // const newResponses =
      const updatedCandidate = {
        ...candidate,
        responses: [
          ...candidate?.responses?.map((response) => {
            if (
              changeAnswer[response._id] &&
              changeAnswer[response._id] === true
            ) {
              //console.log(`Answer value`, answerValue[response._id], response._id);
              return { ...response, value: answerValue[response._id] };
            }
            return response;
          }),
        ],
      };

      await axios.put(`candidates/${id}`, updatedCandidate, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user.token")}`,
        },
      });
      history.push(`/candidate/${id}`);
    } catch (e) {
      console.error(e);
    }
    swal({
      title: "Save Changes successfully",
      icon: "success",
    });
  }

  return (
    <If test={isLoading === false && candidate}>
      <div className="row">
        <div className="col-md-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h5 className="m-0 font-weight-bold text-primary">Responses </h5>
            </div>
            <div className="card-body">
              <table className="table bg-white">
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Click checkbox to Edit Answer</th>
                    {/* <th>Change Answer</th> */}
                  </tr>
                </thead>
                <tbody>
                  {candidate?.responses
                    .filter((response) => {
                      //console.log(`Response`, response)
                      const nonEditableTypes = [
                        //"texttable",
                        "radio",
                        "checkbox",
                      ];
                      return !nonEditableTypes.includes(response.element.type);
                    })
                    .map((response, k) => {
                      //console.log(`Response value`, response.value)
                      let value = response.value;
                      if (response.element.type === "checkbox") {
                        value = Array.isArray(value) ? value.join(", ") : (value || "");
                      }
                      if (response.element.type === "texttable") {
                        value = (
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                {response.element.properties.options.map(
                                  (option, k) => (
                                    <th key={k}>{option}</th>
                                  )
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {Object.values(JSON.parse(response.value)).map(
                                (v, k) => (
                                  <tr key={k}>
                                    {Object.values(v).map((value, key) => (
                                      <td key={key}>{value}</td>
                                    ))}
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        );
                      }
                      //console.log("response._id", changeAnswer, value)
                      return (
                        <tr key={k}>
                          <th>{response.label}</th>
                          <td>
                            <div className="d-flex align-items-center">
                              <input
                                className="mr-3"
                                type="checkbox"
                                //checked="true"
                                value={
                                  changeAnswer[response._id] &&
                                  changeAnswer[response._id] === true
                                }
                                onChange={(e) => {
                                  setChangeAnswer({
                                    ...changeAnswer,
                                    [response._id]: e.target.checked,
                                    //[response._id]: true,
                                  });
                                  setAnswerValue({
                                    ...answerValue,
                                    [response._id]: value,
                                  });
                                }}
                              />
                              {changeAnswer[response._id] ? (
                                <ResponseEditor
                                  response={response}
                                  value={value}
                                  onChange={(newValue) => {
                                    // console.log("answer value", newValue)
                                    setAnswerValue({
                                      ...answerValue,
                                      [response._id]: newValue,
                                    });
                                  }}
                                />
                              ) : (
                                <div>{value}</div>
                              )}
                            </div>
                          </td>
                          {/* <td>
                            <div className="d-flex">
                              <input
                                type="checkbox"
                                value={
                                  changeAnswer[response._id] &&
                                  changeAnswer[response._id] === true
                                }
                                onChange={(e) => {
                                  setChangeAnswer({
                                    ...changeAnswer,
                                    [response._id]: e.target.checked,
                                  });
                                }}
                              />
                              <div className="ml-3">
                                {changeAnswer[response._id] && (
                                  <ResponseEditor
                                    response={response}
                                    onChange={(newValue) => {
                                      setAnswerValue({
                                        ...answerValue,
                                        [response._id]: newValue,
                                      });
                                    }}
                                  />
                                )}
                              </div>
                            </div>
                          </td> */}
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              <button className="btn btn-primary" onClick={onClickSaveChanges}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <Else>
        <Loading />
      </Else>
    </If>
  );
}

export default CandidateSingleView;
